import * as React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store/types';

export function BuyButton () {
  const { parkingAvailabilityModels } = useSelector(
    (state: AppState) => state.devDocs
  )

  if (parkingAvailabilityModels.length === 0) {
    return <></>
  }
  
  return (
    <button className="btn btn-primary mx-auto my-2">Buy car park ticket for CHF 10.00</button>
  );
}
